(function () {
  function initPfVariantModule(root) {
    if (!root || root.dataset.pfVariantModuleReady === 'true') return;

    root.dataset.pfVariantModuleReady = 'true';

    const wrap = root.querySelector('.variant-swiper .swiper-wrapper');
    const prev = root.querySelector('.variant-prev');
    const next = root.querySelector('.variant-next');

    const tiles = root.querySelectorAll('.selector-item');
    const card = root.querySelector('.plan-card');
    const variantDataEl = root.querySelector('.pf-variant-data');

    const form = root.querySelector('.pf-cart-form');
    const idInput = form?.querySelector('input[name="id"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const planInput = form?.querySelector('input[name="selling_plan"]');

    const EDGE_TOLERANCE = 4;
    const activeCurrency =
      root.dataset.currency ||
      window.Shopify?.currency?.active ||
      'GBP';

    let selectedVariantId = idInput ? idInput.value : "";
    let selectedSellingPlanId = "";
    let selectedMode = "subscribe";
    let isAdding = false;

    let variants = [];

    try {
      variants = JSON.parse(variantDataEl?.textContent || '[]');
    } catch (error) {
      console.error('PF variant data could not be parsed:', error);
    }

    const variantsById = new Map(
      variants.map(variant => [String(variant.id), variant])
    );

    function getRoutesRoot(){
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return "/";
    }

    function getActiveButton(){
      return card?.querySelector('.bundle-add-to-cart') || null;
    }

    function getActiveCard(){
      return card;
    }

    function cssNum(varName, fallback){
      const v = getComputedStyle(root).getPropertyValue(varName).trim();
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    }

    function getScrollAmount(){
      const firstSlide = root.querySelector('.variant-swiper .swiper-slide');
      const gap = cssNum('--pf-gap', 10);

      if (firstSlide) {
        return firstSlide.getBoundingClientRect().width + gap;
      }

      const peek = cssNum('--pf-peek', 44);
      return Math.max(200, wrap.clientWidth - peek);
    }

    function updateArrowState(){
      if (!wrap || !prev || !next) return;

      const maxScroll = wrap.scrollWidth - wrap.clientWidth;
      const hasOverflow = maxScroll > EDGE_TOLERANCE;

      prev.classList.toggle('is-hidden', !hasOverflow);
      next.classList.toggle('is-hidden', !hasOverflow);

      if (!hasOverflow) {
        prev.classList.remove('is-disabled');
        next.classList.remove('is-disabled');
        return;
      }

      const atStart = wrap.scrollLeft <= EDGE_TOLERANCE;
      const atEnd = wrap.scrollLeft >= (maxScroll - EDGE_TOLERANCE);

      prev.classList.toggle('is-disabled', atStart);
      next.classList.toggle('is-disabled', atEnd);
    }

    function formatMoney(value){
      const minorUnits = Number(value);

      if (!Number.isFinite(minorUnits)) {
        return String(value ?? "").trim();
      }

      const locale =
        document.documentElement.lang ||
        navigator.language ||
        'en-GB';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: activeCurrency
        }).format(minorUnits / 100);
      } catch (error) {
        return `${activeCurrency} ${(minorUnits / 100).toFixed(2)}`;
      }
    }

    function escapeHtml(value){
      return String(value ?? "")
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function setHidden(el, hidden){
      if (!el) return;

      const shouldHide = Boolean(hidden);
      el.classList.toggle('pf-is-hidden', shouldHide);

      if (shouldHide) {
        el.style.setProperty('display', 'none', 'important');
      } else {
        el.style.removeProperty('display');
      }
    }

    function setOptionalText(el, value){
  if (!el) return;

  const html = String(value ?? "");
  el.innerHTML = html;
  setHidden(el, !html.trim());
}

function setOptionalMultilineText(el, value){
  if (!el) return;

  const html = String(value ?? "");
  el.innerHTML = html.replace(/\r?\n/g, '<br>');
  setHidden(el, !html.trim());
}

    function updatePriceBox(box, price, compare){
      if (!box) return;

      const priceEl = box.querySelector('.floatprice');
      const compareWrap = box.querySelector('.compareat');
      const compareEl = compareWrap?.querySelector('s');

      if (priceEl) {
        priceEl.textContent = formatMoney(price);
      }

      const hasCompare = String(compare ?? "").trim() !== "";

      if (compareEl) {
        compareEl.textContent = hasCompare ? formatMoney(compare) : "";
      }

      setHidden(compareWrap, !hasCompare);
    }

    function renderSubscriptionIncludes(items){
  if (!card) return;

  const section = card.querySelector('.pf-subscription-includes');
  const list = card.querySelector('.pf-subscription-include-list');

  if (!section || !list) return;

  const safeItems = Array.isArray(items) ? items : [];

  list.innerHTML = safeItems.map(item => {
    const image = String(item?.image ?? "");
    const month = String(item?.month ?? "");
    const title = String(item?.title ?? "");
    const price = String(item?.price ?? "");
    const priceParts = price.split('|').map(part => part.trim());

    const imageHtml = image
      ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">`
      : '';

    const monthHtml = month
      ? `<div class="pf-subscription-include-month">${month}</div>`
      : '';

    const titleHtml = title
      ? `<div class="pf-subscription-include-title">${title}</div>`
      : '';

    let priceHtml = '';

    if (price) {
      priceHtml = priceParts.length > 1
        ? `<div class="pf-subscription-include-price"><span class="pf-subscription-include-price-was"><s>${priceParts[0]}</s></span><span class="pf-subscription-include-price-now">${priceParts[1]}</span></div>`
        : `<div class="pf-subscription-include-price"><span class="pf-subscription-include-price-now">${price}</span></div>`;
    }

    return `
      <div class="pf-subscription-include-row">
        <div class="pf-subscription-include-image">${imageHtml}</div>
        <div class="pf-subscription-include-main">${monthHtml}${titleHtml}</div>
        ${priceHtml}
      </div>
    `;
  }).join('');

  setHidden(section, safeItems.length === 0);
}

    function renderPriceCopy(variant){
  if (!card) return;

  const priceCopy = card.querySelector('.price-copy');
  if (!priceCopy) return;

  const items = [
    variant.supplyDuration,
    variant.subscribeSavingText,
    variant.subscribeManageText,
    variant.subscribeDeliveryText
  ].map(value => String(value ?? "").trim()).filter(Boolean);

  priceCopy.innerHTML = items
    .map(item => `<div class="price-copy-item">${item}</div>`)
    .join('');

  setHidden(priceCopy, items.length === 0);
}

    function renderVariant(variant){
      if (!card || !variant) return;

      card.dataset.product = String(variant.id || "");
      card.dataset.variantId = String(variant.id || "");
      card.dataset.planId = String(variant.planId || "");
      card.dataset.priceSub = String(variant.priceSub || "");
      card.dataset.compareSub = String(variant.compareSub || "");
      card.dataset.priceOne = String(variant.priceOne || "");
      card.dataset.compareOne = String(variant.compareOne || "");

      const image = card.querySelector('.plan-img');
      const title = card.querySelector('.plan-title');
      const subtitle = card.querySelector('.plan-sub');
      const planCopy = card.querySelector('.plan-copy');
      const subscribeBox = card.querySelector('.price-box[data-value="subscribe"]');
      const oneOffBox = card.querySelector('.price-box[data-value="one-off"]');

      if (image) {
        if (variant.image) {
          image.src = variant.image;
          image.alt = variant.imageAlt || variant.title || "";
          setHidden(image, false);
        } else {
          image.removeAttribute('src');
          image.alt = "";
          setHidden(image, true);
        }
      }

      if (title) {
        title.textContent = variant.title || "";
      }

      setOptionalText(subtitle, variant.subtitle);
      setOptionalMultilineText(planCopy, variant.planCopy);

      updatePriceBox(subscribeBox, variant.priceSub, variant.compareSub);
      updatePriceBox(oneOffBox, variant.priceOne, variant.compareOne);
      renderSubscriptionIncludes(variant.subscriptionIncludes);
      renderPriceCopy(variant);
    }

    function setFormValues(variantId, planId){
      selectedVariantId = variantId || "";
      selectedSellingPlanId = planId || "";

      if (idInput) idInput.value = selectedVariantId;
      if (quantityInput) quantityInput.value = "1";

      if (planInput) {
        if (selectedSellingPlanId) {
          planInput.disabled = false;
          planInput.value = selectedSellingPlanId;
        } else {
          planInput.value = "";
          planInput.disabled = true;
        }
      }
    }

    function updateButton(price, compare){
      const btn = getActiveButton();
      if (!btn) return;

      const label = btn.querySelector('.pf-cart-label');
      const priceWrap = btn.querySelector('.pf-cart-price');
      const compareEl = priceWrap?.querySelector('s');
      const priceEl = priceWrap?.querySelector('span');

      if (label) {
        label.textContent = 'Add to cart';
      }

      const hasCompare = String(compare ?? "").trim() !== "";

      if (compareEl) {
        compareEl.textContent = hasCompare ? formatMoney(compare) : "";
        setHidden(compareEl, !hasCompare);
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(price);
      }
    }

    function setSelectedPriceMode(activeCard, mode){
      if (!activeCard) return;

      selectedMode = mode || "subscribe";

      const boxes = activeCard.querySelectorAll('.price-box');
      boxes.forEach(box => {
        box.classList.toggle('selected', box.dataset.value === selectedMode);
      });

      const variantId = activeCard.dataset.variantId || "";
      const planId = selectedMode === "subscribe"
        ? (activeCard.dataset.planId || "")
        : "";

      const price = selectedMode === "subscribe"
        ? activeCard.dataset.priceSub
        : activeCard.dataset.priceOne;

      const compare = selectedMode === "subscribe"
        ? activeCard.dataset.compareSub
        : activeCard.dataset.compareOne;

      setFormValues(variantId, planId);
      updateButton(price, compare);

      const btn = getActiveButton();

      if (btn) {
        btn.dataset.variantId = variantId;
        btn.dataset.sellingPlan = planId;
        btn.dataset.mode = selectedMode;
      }
    }

    function scrollSlideHorizontally(slide, behavior = 'smooth') {
      if (!wrap || !slide) return;

      const targetLeft = slide.offsetLeft - ((wrap.clientWidth - slide.clientWidth) / 2);
      const safeLeft = Math.max(0, targetLeft);

      if (typeof wrap.scrollTo === 'function') {
        wrap.scrollTo({
          left: safeLeft,
          behavior: behavior
        });
      } else {
        wrap.scrollLeft = safeLeft;
      }
    }

    function setActive(productKey, shouldScroll = false){
      const variant = variantsById.get(String(productKey));

      tiles.forEach(tile => {
        const isActive = tile.dataset.product === String(productKey);
        tile.classList.toggle('active', isActive);

        const slide = tile.closest('.swiper-slide');
        if (slide) slide.classList.toggle('active', isActive);
      });

      if (!variant || !card) return;

      renderVariant(variant);
      setSelectedPriceMode(card, "subscribe");

      if (shouldScroll) {
        const activeTile = root.querySelector('.selector-item.active');
        const slide = activeTile ? activeTile.closest('.swiper-slide') : null;

        if (slide) {
          scrollSlideHorizontally(slide, 'smooth');
        }
      }

      setTimeout(updateArrowState, 250);
    }

    function updateCartCount(cart){
      if (!cart || typeof cart.item_count === "undefined") return;

      const selectors = [
        '[data-cart-count]',
        '.cart-count',
        '.cart-count-bubble span',
        '.site-header__cart-count span',
        '#CartCount',
        '[data-header-cart-count]'
      ];

      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
      });
    }

    function dispatchCartEvents(addedItem, cart){
      const detail = {
        item: addedItem,
        product: addedItem,
        cart: cart
      };

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true, detail }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles:true, detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles:true, detail }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles:true, detail }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true, detail }));
      window.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
    }

    function openCartDrawer(){
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }

      if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
        return;
      }

      const drawer = document.querySelector(
        '#CartDrawer, .cart-drawer, [data-cart-drawer], .drawer--cart'
      );

      if (drawer) {
        drawer.classList.add('active', 'is-active', 'is-open', 'animate');
        document.body.classList.add('cart-drawer-open', 'js-drawer-open-cart');
      }
    }

    async function addSelectedToCart(){
      if (isAdding) return;

      const activeCard = getActiveCard();

      if (activeCard) {
        const activePriceBox = activeCard.querySelector('.price-box.selected');
        const mode = activePriceBox ? activePriceBox.dataset.value : selectedMode;
        setSelectedPriceMode(activeCard, mode);
      }

      const btn = getActiveButton();
      const variantId = selectedVariantId || (idInput ? idInput.value : "");
      const sellingPlanId = selectedSellingPlanId || "";

      if (!variantId) return;

      isAdding = true;

      if (btn) {
        btn.classList.add('is-loading');
        btn.disabled = true;
      }

      const payload = {
        id: Number(variantId),
        quantity: 1
      };

      if (sellingPlanId) {
        payload.selling_plan = Number(sellingPlanId);
      }

      try {
        const routesRoot = getRoutesRoot();

        const addResponse = await fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const addedItem = await addResponse.json();

        if (!addResponse.ok) {
          throw addedItem;
        }

        let cart = null;

        try {
          const cartResponse = await fetch(routesRoot + 'cart.js', {
            method: 'GET',
            headers: {
              'Accept': 'application/json'
            }
          });

          if (cartResponse.ok) {
            cart = await cartResponse.json();
          }
        } catch (cartError) {}

        updateCartCount(cart);
        dispatchCartEvents(addedItem, cart);
        openCartDrawer();

      } catch (error) {
        console.error('Add to cart failed:', error);

        if (error && error.description) {
          alert(error.description);
        } else if (error && error.message) {
          alert(error.message);
        } else {
          alert('Sorry, this item could not be added to cart. Please try again.');
        }

      } finally {
        isAdding = false;

        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      }
    }

    function getLondonParts(date){
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      const parts = formatter.formatToParts(date);
      const map = {};

      parts.forEach(part => {
        if (part.type !== 'literal') {
          map[part.type] = part.value;
        }
      });

      return {
        year: Number(map.year),
        month: Number(map.month),
        day: Number(map.day),
        hour: Number(map.hour),
        minute: Number(map.minute),
        second: Number(map.second)
      };
    }

    function londonLocalToDate(year, month, day, hour, minute, second){
      const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      const guessParts = getLondonParts(utcGuess);

      const guessAsUTC = Date.UTC(
        guessParts.year,
        guessParts.month - 1,
        guessParts.day,
        guessParts.hour,
        guessParts.minute,
        guessParts.second
      );

      const targetAsUTC = Date.UTC(year, month - 1, day, hour, minute, second);
      const diff = targetAsUTC - guessAsUTC;

      return new Date(utcGuess.getTime() + diff);
    }

    function getDispatchTarget(){
      const now = new Date();
      const londonNow = getLondonParts(now);

      let target = londonLocalToDate(
        londonNow.year,
        londonNow.month,
        londonNow.day,
        20,
        0,
        0
      );

      let dayText = 'today';

      if (now.getTime() >= target.getTime()) {
        const tomorrowBase = londonLocalToDate(
          londonNow.year,
          londonNow.month,
          londonNow.day,
          12,
          0,
          0
        );

        tomorrowBase.setUTCDate(tomorrowBase.getUTCDate() + 1);

        const tomorrowLondon = getLondonParts(tomorrowBase);

        target = londonLocalToDate(
          tomorrowLondon.year,
          tomorrowLondon.month,
          tomorrowLondon.day,
          20,
          0,
          0
        );

        dayText = 'tomorrow';
      }

      return { target, dayText };
    }

    function updateDispatchCountdown(){
      const countdownEl = card?.querySelector('.pf-dispatch-countdown');
      const dayLabelEl = card?.querySelector('.pf-dispatch-day-label');

      if (!countdownEl || !dayLabelEl) return;

      const now = new Date();
      const dispatchData = getDispatchTarget();
      const diffMs = Math.max(0, dispatchData.target.getTime() - now.getTime());

      const totalMinutes = Math.floor(diffMs / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      countdownEl.textContent = `${hours}h ${minutes}m`;
      dayLabelEl.textContent = dispatchData.dayText;
    }

    prev?.addEventListener('click', () => {
      if (prev.classList.contains('is-disabled')) return;
      wrap?.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      if (next.classList.contains('is-disabled')) return;
      wrap?.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    tiles.forEach(tile => {
      tile.addEventListener('click', () => {
        setActive(tile.dataset.product, true);
      });
    });

    root.addEventListener('click', (event) => {
      const box = event.target.closest('.price-box');

      if (box) {
        const activeCard = box.closest('.plan-card');
        if (!activeCard) return;

        setSelectedPriceMode(activeCard, box.dataset.value);
        return;
      }

      const addBtn = event.target.closest('.bundle-add-to-cart');

      if (addBtn) {
        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        addSelectedToCart();
      }
    });

    wrap?.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);

    if ('ResizeObserver' in window && wrap) {
      const ro = new ResizeObserver(updateArrowState);
      ro.observe(wrap);
    }

    const bestValueTile = tiles[1];

    const initial =
      bestValueTile?.dataset.product ||
      root.querySelector('.selector-item.active')?.dataset.product ||
      card?.dataset.product ||
      tiles[0]?.dataset.product;

    if (initial) {
      setActive(initial);
    }

    updateDispatchCountdown();
    setInterval(updateDispatchCountdown, 30000);

    requestAnimationFrame(updateArrowState);
    setTimeout(updateArrowState, 150);
  }

  function initPfVariantModules(scope) {
    const searchRoot = scope || document;

    const roots = searchRoot.matches && searchRoot.matches('.pf-variant-module')
      ? [searchRoot]
      : searchRoot.querySelectorAll('.pf-variant-module');

    roots.forEach(initPfVariantModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPfVariantModules(document);
    });
  } else {
    initPfVariantModules(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPfVariantModules(event.target);
  });

  window.PfVariantModuleInit = initPfVariantModules;
})();